// extracted by mini-css-extract-plugin
export default {"passwordEditor":"UserForm_passwordEditor__8z5EB","showHiddenIcon":"UserForm_showHiddenIcon__TAXBg","passwordItem":"UserForm_passwordItem__saWWO"};